import type { ComponentProps } from 'react';
import React from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';
import { IconLink } from '../../../Icon';
import { ModalRow } from '../ModalRow';

import type { PaletteProps } from '../../Modal.types';

export const ModalCloseBtn = (props: ModalCloseBtnProps) => {
  const { width = 36, height = 36, palette, ...rest } = props;

  const { match } = useResponsive();
  const responsiveStyles = match([styles.closeBtnWrapperMobile, styles.closeBtnWrapperTabletUp]);

  // @ts-expect-error error TS7053: Element implicitly has an 'any' type becau
  const paletteSpecificColor = palette ? iconColors[palette] : undefined;

  return (
    <ModalRow style={[styles.closeBtnWrapper, responsiveStyles, props.style]}>
      <IconLink
        name="IconClose"
        palette="muted"
        accessibilityLabel="Close dialog"
        width={width}
        height={height}
        color={paletteSpecificColor}
        {...rest}
      />
    </ModalRow>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  closeBtnWrapper: {
    alignItems: 'flex-end',
    paddingBottom: theme.spacing['4'],
  },
  closeBtnWrapperMobile: {
    paddingTop: theme.spacing['4'],
  },
  closeBtnWrapperTabletUp: {
    paddingTop: theme.spacing['6'],
  },
});

// ─── Palette Styles ────────────────────────────────────────────────────

const iconColors = {
  primary: undefined,
  neutral: theme.colors.BLACK,
  secondary: theme.colors.WHITE,
  lime: theme.colors.WHITE,
  muted: theme.colors.CHARCOAL,
};

// ─── Types ─────────────────────────────────────────────────────────────

type ModalCloseBtnProps = Omit<ComponentProps<typeof IconLink>, 'name' | 'palette'> & PaletteProps;
